import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

export default function DraggablePaper(props) {
    console.log("props...", props)
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
